import { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import dayjs from 'dayjs';

import { actions } from 'features/bonusProgram/redux';

import { searchInItems } from 'features/bonusProgram/data';

import { convertPromotions } from './convertPromotions';

const usePromotions = () => {
  const dispatch = useDispatch();
  const locale = useSelector(state => state.locale.locale, shallowEqual);
  const { actionProcessing } = useSelector(state => state.bonusProgram, shallowEqual);

  const [count, setCount] = useState(10);
  const [page, setPage] = useState(0);

  const [date, setDate] = useState({
    beginDate: new Date(dayjs().startOf('date')),
    endDate: new Date(dayjs().add(1, 'day').startOf('date')),
  });
  const [activeDay, setActiveDay] = useState('');

  const [filters, setFilters] = useState({
    lang: searchInItems[0],
    user: '',
  });

  const [statusAll, setStatusAll] = useState(true);
  const [statusActive, setStatusActive] = useState(false);
  const [statusInactive, setStatusInactive] = useState(false);

  const handleSearch = () => {
    const requestedData = {
      lang: filters.lang.value,
      count,
      page,
      beginDate: date.beginDate,
      endDate: date.endDate,
      statusAll,
      statusActive,
      statusInactive,
    };

    dispatch(actions.getPromotions(convertPromotions(requestedData)));
  };

  const handleDeletePromotion = id => {
    dispatch(actions.deletePromotion(id, handleSearch));
  };

  const onClickSearch = () => {
    setPage(0);
    handleSearch();
  };

  const onItemsOnPageChanged = newItemsOnPage => {
    setCount(newItemsOnPage);
    setPage(0);
  };

  const onChangeBeginDate = value => {
    if (!isNaN(value.valueOf())) {
      setDate(prev => ({ ...prev, beginDate: value }));
      setActiveDay('');
    }
  };

  const onChangeEndDate = value => {
    if (!isNaN(value.valueOf())) {
      setDate(prev => ({ ...prev, endDate: value }));
    }
  };

  const onChangeActiveDay = dayFilter => {
    setActiveDay(dayFilter);
    setDate(prev => ({
      ...prev,
      beginDate: dayFilter.value,
      endDate: dayFilter.value2,
    }));
  };

  useEffect(() => {
    handleSearch();
  }, [count, page]);

  return {
    actionProcessing,
    locale,

    count,
    page,
    date,
    activeDay,
    filters,

    statusAll,
    setStatusAll,
    statusActive,
    setStatusActive,
    statusInactive,
    setStatusInactive,

    onItemsOnPageChanged,
    setPage,
    setFilters,
    onClickSearch,
    onChangeBeginDate,
    onChangeEndDate,
    onChangeActiveDay,
    handleSearchInChange: value => {
      const searchInItem = searchInItems.find(item => item.value === value);
      setFilters(prev => ({ ...prev, lang: searchInItem }));
    },
    handleDeletePromotion,
  };
};

export default usePromotions;
